import type { PdfPrimitive } from '../..';
import PdfContentStreamOperator from '../pdfPrimitives/PdfContentStreamOperator';

export default class OperatorWithOperands {
  constructor(
    public operator: PdfContentStreamOperator,
    public operands: PdfPrimitive[]
  ) {}
}
